import {SnackbarContent, CustomContentProps} from "notistack";
import React from "react";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';



const CustomInfo = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {

    const {
        message
    } = props

    return (
        <SnackbarContent ref={ref}>
            <div className="alert alert--primary alert--alt" style={{minWidth: "250px"}}>
                <div className="alert__prefix">
                    <InfoSharpIcon />
                </div>
                <div className="alert__header">{message}</div>
            </div>
        </SnackbarContent>
    )
})

export {CustomInfo}